import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import INotice from '../../interfaces/notice';
import { removeNotice } from '../../store/global-slice';
import { RootState } from '../../store/store';
import Notice from './notice';
import css from './notices.module.css';

export default function Notices({
  accessor,
  children,
}: {
  accessor: string;
  children: ReactElement<typeof Notice>;
}) {
  const dispatch = useDispatch();
  const [notices, setNotices] = useState<INotice[]>([]);
  const { stateNotices } = useSelector((state: RootState) => ({
    stateNotices: state.global.notices,
  }));

  useEffect(() => {
    const filteredNotices = stateNotices.filter(
      (notice) => notice.accessor === accessor
    );
    if (filteredNotices.length) {
      setNotices(filteredNotices);
      dispatch(removeNotice(accessor));
    }
  }, [stateNotices, accessor, dispatch]);

  function remove(id: string | number) {
    setNotices(notices.filter((notice, index) => index !== id));
  }

  function noticeStatus(status: string) {
    switch (status) {
      case 'success':
        return status;
      case 'warning':
        return status;
      case 'error':
        return status;
      default:
        return null;
    }
  }

  return (
    <div className={css['notices']}>
      {children}
      {notices.map((notice, index) => (
        <Notice
          key={index}
          status={noticeStatus(notice.status)}
          text={notice.description}
          onDismiss={() => {
            remove(index);
          }}
        />
      ))}
    </div>
  );
}
